/* ===== RAGE PAGE LOADER — Tunnel Vision =====
   v7.0 — Logo sempre visibile, conflict-free
   ============================================= */

(function() {
  'use strict';

  var CONFIG = {
    speedIn: 500,
    speedOut: 350,
    logoVisibleMs: 400,
    excludedPaths: ['/checkout', '/admin', '/cart', '/account/login', '/account/register'],
    excludedHosts: ['cdn.shopify.com', 'cdn.shopifycloud.com'],
  };

  var PATHS = {
    initial: 'M -18 -26.90625 L -18 86.90625 L 98 86.90625 L 98 -26.90625 L -18 -26.90625 Z M 40 -25.6875 C 70.750092 -25.6875 95.6875 -0.7500919 95.6875 30 C 95.6875 60.750092 70.750092 85.6875 40 85.6875 C 9.2499078 85.6875 -15.6875 60.750092 -15.6875 30 C -15.6875 -0.7500919 9.2499078 -25.6875 40 -25.6875 Z',
    tunnel:  'M -18 -26.90625 L -18 86.90625 L 98 86.90625 L 98 -26.90625 L -18 -26.90625 Z M 40 29.96875 C 40.01804 29.96875 40.03125 29.98196 40.03125 30 C 40.03125 30.01804 40.01804 30.03125 40 30.03125 C 39.98196 30.03125 39.96875 30.01804 39.96875 30 C 39.96875 29.98196 39.98196 29.96875 40 29.96875 Z',
  };

  var COLORS = ['#ff6b1a', '#c44a00'];

  var state = {
    isAnimating: false,
    isNavigating: false,
    animFrame: null,
    loaderEl: null,
    pathEl: null,
    logoEl: null,
    reverse: false,
  };

  // ── Cleanup totale ─────────────────────────────
  function forceCleanup() {
    if (state.animFrame) {
      cancelAnimationFrame(state.animFrame);
      state.animFrame = null;
    }
    var stale = document.getElementById('rage-page-loader');
    if (stale) stale.remove();
    state.loaderEl = null;
    state.pathEl = null;
    state.logoEl = null;
    state.isAnimating = false;
    state.isNavigating = false;
    document.body.classList.remove('rage-navigating');
  }

  // ── Colore casuale ─────────────────────────────
  function getRandomColor() {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
  }

  // ── Build DOM ──────────────────────────────────
  function buildLoader() {
    var existing = document.getElementById('rage-page-loader');
    if (existing) existing.remove();

    var color = getRandomColor();
    var fromPath = state.reverse ? PATHS.tunnel : PATHS.initial;

    var el = document.createElement('div');
    el.id = 'rage-page-loader';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 80 60" preserveAspectRatio="xMidYMid slice">' +
        '<path fill="' + color + '" d="' + fromPath + '"/>' +
      '</svg>' +
      (window.__rageLoaderLogo
        ? '<div class="rage-loader-logo" id="rage-loader-logo"><img src="' + window.__rageLoaderLogo + '" alt="Rage" /></div>'
        : '');

    document.body.appendChild(el);
    state.loaderEl = el;
    state.pathEl = el.querySelector('path');
    state.logoEl = el.querySelector('#rage-loader-logo');
  }

  // ── Animazione path ────────────────────────────
  function parseCoords(d) {
    return d.match(/-?[\d.]+(?:e[-+]?\d+)?/g).map(Number);
  }

  function animatePath(fromD, toD, duration, easing, callback) {
    var start = null;
    var fromCoords = parseCoords(fromD);
    var toCoords = parseCoords(toD);

    function step(timestamp) {
      if (!state.pathEl) return;
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = easing(progress);
      var idx = 0;
      var interpolated = fromD.replace(/-?[\d.]+(?:e[-+]?\d+)?/g, function() {
        var v = fromCoords[idx] + (toCoords[idx] - fromCoords[idx]) * eased;
        idx++;
        return v.toFixed(5);
      });
      state.pathEl.setAttribute('d', interpolated);
      if (progress < 1) {
        state.animFrame = requestAnimationFrame(step);
      } else {
        state.animFrame = null;
        callback && callback();
      }
    }
    state.animFrame = requestAnimationFrame(step);
  }

  function easeInOut(t) { return t < 0.5 ? 2*t*t : -1+(4-2*t)*t; }
  function easeOut(t) { return t*(2-t); }

  // ── Logo ───────────────────────────────────────
  function showLogo() {
    if (state.logoEl) state.logoEl.classList.add('is-visible');
  }

  // ── Show loader ────────────────────────────────
  function showLoader(onComplete) {
    buildLoader();
    state.isAnimating = true;
    state.loaderEl.classList.add('is-visible');

    var fromPath = state.reverse ? PATHS.tunnel : PATHS.initial;
    var toPath   = state.reverse ? PATHS.initial : PATHS.tunnel;

    animatePath(fromPath, toPath, CONFIG.speedIn, easeInOut, function() {
      if (!state.isNavigating) return;
      showLogo();
      setTimeout(function() {
        state.isAnimating = false;
        onComplete && onComplete();
      }, CONFIG.logoVisibleMs);
    });
  }

  // ── Link check ─────────────────────────────────
  function isInternalLink(href) {
    if (!href) return false;
    if (href.startsWith('#')) return false;
    if (/^(mailto|tel|javascript):/.test(href)) return false;
    try {
      var url = new URL(href, window.location.origin);
      if (url.hostname !== window.location.hostname) return false;
      if (CONFIG.excludedHosts.indexOf(url.hostname) !== -1) return false;
      if (CONFIG.excludedPaths.some(function(p) { return url.pathname.startsWith(p); })) return false;
      if (url.pathname === window.location.pathname && url.hash) return false;
      return true;
    } catch(e) { return false; }
  }

  // ── Click handler ──────────────────────────────
  function handleClick(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.defaultPrevented) return;
    if (state.isAnimating || state.isNavigating) return;

    var link = e.target.closest('a[href]');
    if (!link) return;
    if (link.getAttribute('target') === '_blank') return;
    if (link.hasAttribute('download')) return;

    var href = link.getAttribute('href');
    if (!isInternalLink(href)) return;

    e.preventDefault();
    state.isNavigating = true;
    document.body.classList.add('rage-navigating');

    try {
      var url = new URL(href, window.location.origin);
      state.reverse = (url.pathname === '/' || url.pathname === '');
    } catch(err) {
      state.reverse = false;
    }

    showLoader(function() {
      window.location.href = href;
    });
  }

  // ── Init ───────────────────────────────────────
  function init() {
    if ('startViewTransition' in document && document.documentElement.hasAttribute('data-shopify-view-transitions')) return;

    forceCleanup();

    document.addEventListener('click', handleClick, { passive: false });

    window.addEventListener('popstate', function() {
      if (state.isAnimating || state.isNavigating) return;
      state.reverse = true;
      state.isNavigating = true;
      document.body.classList.add('rage-navigating');
      buildLoader();
      state.loaderEl.classList.add('is-visible');
      showLoader(function() {
        forceCleanup();
      });
    });

    window.addEventListener('pageshow', function(e) {
      if (e.persisted) forceCleanup();
    });

    window.addEventListener('load', function() {
      setTimeout(forceCleanup, 150);
    });

    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') return;
      setTimeout(forceCleanup, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
